import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDollarReceiveLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.1665 2.7598C5.13064 2.7598 2.6665 5.12538 2.6665 8.0398C2.6665 10.9542 5.13064 13.3198 8.1665 13.3198C11.2024 13.3198 13.6665 10.9542 13.6665 8.0398C13.6665 7.77472 13.8904 7.5598 14.1665 7.5598C14.4426 7.5598 14.6665 7.77472 14.6665 8.0398C14.6665 11.4844 11.7546 14.2798 8.1665 14.2798C4.57836 14.2798 1.6665 11.4844 1.6665 8.0398C1.6665 4.59519 4.57836 1.7998 8.1665 1.7998C8.44264 1.7998 8.6665 2.01471 8.6665 2.2798C8.6665 2.5449 8.44264 2.7598 8.1665 2.7598Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.19645 7.10835C6.19645 6.34613 6.84024 5.72855 7.63437 5.72855H9.37537C9.6515 5.72855 9.87537 5.94346 9.87537 6.20855C9.87537 6.47365 9.6515 6.68855 9.37537 6.68855H7.63437C7.39204 6.68855 7.19644 6.87673 7.19644 7.10835C7.19644 7.3408 7.39224 7.52876 7.63437 7.52876H8.70597C9.4997 7.52876 10.1432 8.14656 10.1432 8.9086C10.1432 9.67104 9.49997 10.289 8.70597 10.289H6.96437C6.68817 10.289 6.46434 10.0741 6.46434 9.80902C6.46434 9.54393 6.68817 9.32902 6.96437 9.32902H8.70597C8.94724 9.32902 9.14324 9.14124 9.14324 8.9086C9.14324 8.6768 8.94744 8.48876 8.70597 8.48876H7.63437C6.83997 8.48876 6.19645 7.87097 6.19645 7.10835Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.17044 4.96731C8.44657 4.96731 8.67044 5.18221 8.67044 5.44731V6.20949C8.67044 6.47459 8.44657 6.68949 8.17044 6.68949C7.89424 6.68949 7.67044 6.47459 7.67044 6.20949V5.44731C7.67044 5.18221 7.89424 4.96731 8.17044 4.96731ZM8.17044 9.32742C8.44657 9.32742 8.67044 9.54233 8.67044 9.80742V10.5634C8.67044 10.8285 8.44657 11.0434 8.17044 11.0434C7.89424 11.0434 7.67044 10.8285 7.67044 10.5634V9.80742C7.67044 9.54233 7.89424 9.32742 8.17044 9.32742Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.268 2.7298C11.5442 2.7298 11.768 2.94471 11.768 3.2098V4.58172H13.1972C13.4733 4.58172 13.6972 4.79662 13.6972 5.06172C13.6972 5.32682 13.4733 5.54172 13.1972 5.54172H11.268C10.9919 5.54172 10.768 5.32682 10.768 5.06172V3.2098C10.768 2.94471 10.9919 2.7298 11.268 2.7298Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.2253 2.22289C14.4206 2.41035 14.4206 2.71426 14.2253 2.90171L11.6216 5.40127C11.4264 5.58872 11.1098 5.58872 10.9145 5.40127C10.7192 5.21382 10.7192 4.9099 10.9145 4.72245L13.5182 2.2229C13.7134 2.03544 14.03 2.03544 14.2253 2.22289Z",
			fill: "currentColor"
		})
	]
});
export default SvgDollarReceiveLine;
